export enum GeocodingStatus {
  Ok = 'OK',
  ZeroResults = 'ZERO_RESULTS',
  OverDailyLimit = 'OVER_DAILY_LIMIT',
  OverQueryLimit = 'OVER_QUERY_LIMIT',
  RequestDenied = 'REQUEST_DENIED',
  InvalidRequest = 'INVALID_REQUEST',
  UnknownError = 'UNKNOWN_ERROR',
}
